import { createSelector } from '@ngrx/store';
import { getMemberFormFields } from '../getMemberFormFields';

export const getUpdateMemberFormFields = createSelector(getMemberFormFields, (MemberFormFieldsModel) => MemberFormFieldsModel.updatePersonalDetails);
